import { render, staticRenderFns } from "./otodetrmflzx.vue?vue&type=template&id=280cbf17&scoped=true&"
import script from "./otodetrmflzx.vue?vue&type=script&lang=js&"
export * from "./otodetrmflzx.vue?vue&type=script&lang=js&"
import style0 from "./otodetrmflzx.vue?vue&type=style&index=0&id=280cbf17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280cbf17",
  null
  
)

export default component.exports